import { VscSearch } from "react-icons/vsc";
import React, { useContext, useEffect, useState } from "react";
import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
export default function ItemsSelected({
  fastOrderingInfo,
  setFastOrderingInfo,
  selectedItem,
  index,
}) {
  const [selectBox, setSelectedBox] = useState({ seleceBox: "" });
  const getTotalPrice = () => {
    let totalPrice = 0;
    for (
      let index = 0;
      index < fastOrderingInfo[0].itemSelected.length;
      index++
    ) {
      totalPrice += parseInt(
        fastOrderingInfo[0].itemSelected[index].price *
          fastOrderingInfo[0].itemSelected[index].count
      );
    }
    return totalPrice;
  };
  console.log("fastOrderingInfo", fastOrderingInfo);
  function ChangeHandler(index, type) {
    setFastOrderingInfo((prev) => {
      console.log("prev", prev);
      let temp = { ...prev[0] };
      console.log("temp", temp);
      if (type == "plus") {
        temp.itemSelected[index].count += 1;
      } else if (temp.itemSelected[index].count == 1 && type == "minus") {
        temp.itemSelected.splice(index, 1);
      } else {
        temp.itemSelected[index].count -= 1;
      }
      return [temp];
    });
  }
  return (
    <>
      {fastOrderingInfo[0].itemSelected != "" ? (
        <div className="parent-item-select container mt-5 p-4 ">
          <div className="d-flex container justify-content-center  p-2">
            <div className="d-flex-column justify-content-center ">
              آیتم های انتخابی
              <div
                style={{
                  border: "1px solid #fab825",
                  width: "60px",
                  margin: "auto",
                }}
              ></div>
            </div>
          </div>

          {fastOrderingInfo[0].itemSelected.map((value, index) => {
            return (
              <div className="d-flex parent-selected-item">
                {console.log("fastOrderingInfo", value)}
                <div className="parent-img d-flex justify-content-center">
                  <img
                    style={{ borderRadius: "8px" }}
                    src={`http://sabadi.tatdemo.ir//${value.data.main_cover_img[0].path}`}
                  ></img>
                </div>
                <div className="d-flex flex-wrap box-parent">
                  <div className="parent-item">
                    <div className="item-name">فروشگاه</div>
                    <div className="item-value">
                      {value.data.supplier_info[0].title}
                    </div>
                  </div>
                  <div className="parent-item">
                    <div className="item-name">امتیاز</div>
                    <div className="item-value">
                      {value.data.info.avg_product_rate} از10
                    </div>
                  </div>
                  <div className="parent-item">
                    <div className="item-name">محصول</div>
                    <div className="item-value">{value.data.info.title}</div>
                  </div>
                  <div className="parent-item">
                    <div className="item-name">واحد</div>
                    <div className="item-value">
                      {value.data.info.weight_from} کیلو
                    </div>
                  </div>
                  <div className="parent-item">
                    <div className="item-name">تعداد</div>
                    <div className="item-value">
                      <button
                        onClick={() => {
                          ChangeHandler(index, "plus");
                        }}
                        style={{ border: "none", backgroundColor: "#f9f7f8" }}
                      >
                        <FiPlus></FiPlus>
                      </button>
                      {value.count}
                      <button
                        onClick={() => {
                          ChangeHandler(index, "minus");
                        }}
                        style={{ border: "none", backgroundColor: "#f9f7f8" }}
                      >
                        <FiMinus></FiMinus>
                      </button>
                    </div>
                  </div>
                  <div className="parent-item">
                    <div className="item-name">قیمت</div>
                    <div className="item-value">{addCommas(value.price)}</div>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="d-flex justify-content-end mt-3">
            <div style={{ alignSelf: "center", marginLeft: "15px" }}>
              {addCommas(getTotalPrice())} تومان
            </div>
            <div>
              <button type="button" className="btn-item-save">
                ثبت
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
